module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row page-section small-collapse"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [(_vm.hasData) ? _c('div', {
    staticClass: "block block-live-wrapper",
    class: {
      "margin-bottom": !_vm.showError
    }
  }, [_c('h3', {
    staticClass: "live-list-header"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block block-live-small"
  }, [(_vm.showBackButton) ? _c('button', {
    staticClass: "live-list-small-nav live-list-small-nav-prev",
    class: {
      "live-list-small-nav-next": _vm.isNext
    },
    on: {
      "click": _vm.backButtonClicked
    }
  }, [_c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.textShowFirst))])]) : _vm._e(), _vm._v(" "), _c('slider-content'), _vm._v(" "), _c('div', {
    staticClass: "live-list-padding"
  }, [_c('div', {
    staticClass: "live-list-small-scrollbar",
    class: {
      hidden: !_vm.showScrollbar
    },
    attrs: {
      "data-live-list-small-scrollbar": ""
    }
  }, [_vm._m(0)])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showError) ? _c('div', {
    staticClass: "alert-wrapper",
    class: {
      "air-top": _vm.hasData && _vm.showError
    }
  }, [_c('div', {
    staticClass: "alert-hearings"
  }, [_c('h3', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "handle"
  }, [_c('div', {
    staticClass: "mousearea"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3270af71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/Slider.vue
// module id = 96
// module chunks = 1